import React from "react";
import { CardTitle, Col, Table } from "reactstrap";
import { FormattedNumber } from "../Customers/constants/FormatNumber";
import { formatDate, formatDateForDisplay } from "../Utils/UtilityFunctions";

const UsageTable = ({ filteredResources }) => {
  return (
    <Col lg={6} md={12} sm={12} xs={12} className="order-xs-1 order-xl-2 w-100">
      {filteredResources && (
        <div
          className="border px-4 py-3 d-flex flex-column mt-lg-0"
          style={{
            backgroundColor: "#F8FAFC",
            borderRadius: "10px",
            height: "407px",
          }}
        >
          <div className="d-flex justify-content-between align-items-center mb-3">
            <div>
              <CardTitle tag="h5" className="mb-1">
                Usage Breakdown
              </CardTitle>
              <small className="text-muted">Detailed consumption</small>
            </div>
          </div>
          <div className="flex-grow-1" style={{ overflowY: "auto" }}>
            <Table className="mb-0 align-middle table-responsive">
              <thead
                className="sticky-top"
                style={{ backgroundColor: "#F8FAFC", zIndex: 1 }}
              >
                <tr>
                  <th className="fw-semibold">Name</th>
                  <th className="fw-semibold">Value</th>
                  <th className="fw-semibold">Units</th>
                  <th className="fw-semibold d-none d-sm-table-cell">
                    Time&nbsp;Period
                  </th>
                </tr>
              </thead>
              <tbody>
                {filteredResources?.map((r, idx) => (
                  <tr
                    key={idx}
                    style={idx ? { borderTop: "1px solid #f1f3f5" } : undefined}
                  >
                    <td style={{ wordBreak: "break-word", maxWidth: "120px" }}>
                      {r.resourceName}
                    </td>
                    <td style={{ wordBreak: "break-word" }}>
                      <FormattedNumber
                        value={r.consumedBalance}
                        uom=""
                        showUom={false}
                        maxLength={20}
                        isTruncateMiddle={true}
                      />
                    </td>
                    <td style={{ wordBreak: "break-word" }}>{r.uom}</td>
                    <td
                      className="d-none d-sm-table-cell"
                      style={{ fontSize: "0.9rem" }}
                    >
                      {`${formatDateForDisplay(
                        r.validFrom
                      )} – ${formatDateForDisplay(r.validTo)}`}
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        </div>
      )}
    </Col>
  );
};

export default UsageTable;
